import { render, staticRenderFns } from "./program.vue?vue&type=template&id=6737e272&scoped=true"
import script from "./program.vue?vue&type=script&lang=ts"
export * from "./program.vue?vue&type=script&lang=ts"
import style0 from "./program.vue?vue&type=style&index=0&id=6737e272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6737e272",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCustomImage: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/custom-image.vue').default})
